import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    // input: {
    //   paddingTop: theme.spacing.xs,
    //   paddingBottom: theme.spacing.xs,
    // },
    input: 'py-2.5',
  },
}));
